// Setup the configuration for the merchant
const oysterConfig = {
  cartItemRowSelector: '.CartDrawer',
  renderBadgeOnSpecifiedSelector: '',
  apiKey: "api_2HWRGTDRCFLicBK8n",
  integrationID: "integration_2aFUeBmvLS8iFXYud",
  invertBadgeColor: false
};

window.addEventListener("load", function() {
  window.oyster.init({
    apiKey: oysterConfig.apiKey,
    integrationID: oysterConfig.integrationID
  });

  window.oyster.shopify.cart(undefined, { 
    products: [], 
    addBadgeToItems: true, 
    invertBadgeColor: oysterConfig.invertBadgeColor, 
    cartItemRowSelector: oysterConfig.cartItemRowSelector, 
    renderBadgeOnSpecifiedSelector: oysterConfig.renderBadgeOnSpecifiedSelector
  });
});